import {
  addTagAPIPayload,
  apiKeyValidation,
  avatarPayload,
  cookieAPIPayload,
  deleteAvatarImagePayload,
  deleteFontAPIPayload,
  deleteProactiveChat,
  deleteTagAPIPayload,
  domainAPIPayload,
  enableAvatarsPayload,
  enableLanguageSelectionPayload,
  enableMessageFontColorPayload,
  disableVirusScanPayload,
  ProactiveTriggerTags,
  PushNotificationUrl,
  returnAPIdata,
  saveChatPayload,
  selectedFontPayload,
  systemTag,
  transferConnectionAPIPayload,
  TypingBeforeWelcomeMessagePayload,
  updateAttachmentIconPayload,
  updateChannelHopperPlacementPayload,
  updateChatLauncherPayload,
  updateDisplayLogoInfoPayload,
  updateDownloadTranscriptPayload,
  updateEmojiIconPayload,
  updateFooterTextPayload,
  updateHistoryEnabledPayload,
  updateRequiresAuthenticationPayload,
  updateSoundNotificationsPayload,
  updateTypingIndicatorPayload,
  updateWidgetPositionPayload,
  webhookHeader,
  GenAIWatermarkPayload,
  updateEncryptAttachmentsPayload,
  AllowChangingWidgetSize,
  UpdateWidgetDimension,
  EnableVoiceToTextPayload,
  EnableVoiceNotesPayload,
  HasToggleWithoutIframe,
  AgenticLoaderPayload,
  EnableHeartBeatPayload
} from '../../../interfaces/chat';

import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

export async function apiRequestHandler(url: string, requestOptions: any): Promise<returnAPIdata> {
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        return {
          data: json,
          status: response.status,
        };
      } else {
        return {
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return error;
    });
}
export async function deleteAccount(connectionId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_chat',
  );
}

export async function addNewChatAccount(sessionId: string, accountPayload: saveChatPayload) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(`${process.env.REACT_APP_API_PATH}/connections/chat`, requestOptions);
}

export async function updateChatAccount(sessionId: string, connectionId: string, accountPayload: saveChatPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}`,
    requestOptions,
  );
}

export async function loadMultichannel(sessionId: string) {
  if (!sessionId || sessionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/multichannel`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_accounts',
  );
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_chat',
  );
}

export async function addNewDomain(sessionId: string, connectionId: string, domainPayload: domainAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(domainPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/add_domain`,
    requestOptions,
  );
}

export async function deleteDomain(sessionId: string, connectionId: string, domainPayload: domainAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(domainPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_domain`,
    requestOptions,
  );
}

export async function addNewTag(sessionId: string, connectionId: string, tagPayload: addTagAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(tagPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/add_tag`,
    requestOptions,
  );
}

export async function deleteTag(sessionId: string, connectionId: string, tagPayload: deleteTagAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(tagPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_tag`,
    requestOptions,
  );
}

export async function addNewTransferConnection(
  sessionId: string,
  connectionId: string,
  transferConnectionPayload: transferConnectionAPIPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(transferConnectionPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/add_transfer`,
    requestOptions,
  );
}

export async function deleteTransferConnection(
  sessionId: string,
  connectionId: string,
  transferConnectionPayload: transferConnectionAPIPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(transferConnectionPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_transfer`,
    requestOptions,
  );
}

export async function addNewCookie(sessionId: string, connectionId: string, CookiePayload: cookieAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(CookiePayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/add_cookie`,
    requestOptions,
  );
}

export async function deleteCookie(sessionId: string, connectionId: string, CookiePayload: cookieAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(CookiePayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_cookie`,
    requestOptions,
  );
}

export async function updateGeneralInfo(sessionId: string, connectionId: string, generalInfoPayload: systemTag) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(generalInfoPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/system_tags`,
    requestOptions,
  );
}

export async function getLogoMetaData(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/logo-meta`,
    requestOptions,
  );
}

export async function validateUploadLogo(sessionId: string, connectionId: string, requestId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '' || !requestId || requestId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/logo-validate?requestId=${requestId}`,
    requestOptions,
  );
}

export async function updateDisplayLogoInfo(
  sessionId: string,
  connectionId: string,
  payload: updateDisplayLogoInfoPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/display_logo`,
    requestOptions,
  );
}

export async function updateUIToggle(
  togglePath: string,
  sessionId: string,
  connectionId: string,
  payload:
    | updateEmojiIconPayload
    | updateAttachmentIconPayload
    | updateFooterTextPayload
    | updateChatLauncherPayload
    | updateTypingIndicatorPayload
    | updateWidgetPositionPayload
    | updateRequiresAuthenticationPayload
    | updateHistoryEnabledPayload
    | enableLanguageSelectionPayload
    | enableAvatarsPayload
    | updateDownloadTranscriptPayload
    | disableVirusScanPayload
    | avatarPayload
    | enableMessageFontColorPayload
    | apiKeyValidation
    | TypingBeforeWelcomeMessagePayload
    | GenAIWatermarkPayload
    | updateEncryptAttachmentsPayload
    | AllowChangingWidgetSize
    | UpdateWidgetDimension
    | EnableVoiceToTextPayload
    | EnableVoiceNotesPayload
    | HasToggleWithoutIframe
    | AgenticLoaderPayload
    | EnableHeartBeatPayload
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/${togglePath}`,
    requestOptions,
  );
}

export async function updateChannelHopperPlacement(
  sessionId: string,
  connectionId: string,
  payload: updateChannelHopperPlacementPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/channel_hopper_placement`,
    requestOptions,
  );
}

export async function updateAudioNotifications(
  sessionId: string,
  connectionId: string,
  payload: updateSoundNotificationsPayload,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/sound_notification`,
    requestOptions,
  );
}

export async function addNewProactiveChatRecord(
  sessionId: string,
  connectionId: string,
  chatPayload: ProactiveTriggerTags,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;

  const requestOptions = {
    body: JSON.stringify(chatPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/add_proactive_trigger`,
    requestOptions,
  );
}

export async function deleteProactiveChatRecord(
  sessionId: string,
  connectionId: string,
  chatPayload: deleteProactiveChat,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(chatPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_proactive_trigger`,
    requestOptions,
  );
}

export async function updateProactiveChatRecord(
  sessionId: string,
  connectionId: string,
  chatPayload: deleteProactiveChat,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(chatPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/update_proactive_trigger`,
    requestOptions,
  );
}

export async function updatePushNotificationUrl(sessionId: string, connectionId: string, payload: PushNotificationUrl) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/push_notification_webhook`,
    requestOptions,
  );
}

export async function addNewHeader(sessionId: string, connectionId: string, payload: webhookHeader) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const final = { webhookHeaders: payload };
  const requestOptions = {
    body: JSON.stringify(final),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };
  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/push_notification_headers`,
    requestOptions,
  );
}

export async function deleteHeader(sessionId: string, connectionId: string, chatPayload: webhookHeader) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(chatPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_push_notification_header`,
    requestOptions,
  );
}

export async function updateWidgetButton(sessionId: string, connectionId: string, payload: any) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/widget_button_type`,
    requestOptions,
  );
}

export async function getFontFileMetaData(sessionId: string, connectionId: string, fileNameWithoutExtension: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
      'x-file-name': fileNameWithoutExtension,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/font-meta`,
    requestOptions,
  );
}

export async function validateUploadFontFile(
  sessionId: string,
  connectionId: string,
  requestId: string,
  fileNameWithoutExtension: string,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '' || !requestId || requestId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
      'x-file-name': fileNameWithoutExtension,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/font-validate?requestId=${requestId}`,
    requestOptions,
  );
}

export const getCustomFileUploadMetaData = async (
  sessionId: string,
  connectionId: string,
  fileNameWithoutExtension: string,
) => {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
      'x-file-name': fileNameWithoutExtension,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/custom-field-localization-meta`,
    requestOptions,
  );
};

export const validateUploadLanguageTemplate = async (
  sessionId: string,
  connectionId: string,
  requestId: string,
  fileNameWithoutExtension: string,
) => {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '' || !requestId || requestId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
      'x-file-name': fileNameWithoutExtension,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/custom-field-localization-validate?requestId=${requestId}`,
    requestOptions,
  );
};

export const setUpdateCustomTranslation = async (sessionId: string, connectionId: string, data: any) => {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/set_update_custom_translation`,
    requestOptions,
  );
};

export async function deletefontRecord(sessionId: string, connectionId: string, tagPayload: deleteFontAPIPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(tagPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_font`,
    requestOptions,
  );
}

export async function getImageMetaData(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/avatar-meta`,
    requestOptions,
  );
}

export async function validateUploadAvatarImg(
  sessionId: string,
  connectionId: string,
  requestId: string,
  avatarImg: string,
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '' || !requestId || requestId === '') return;
  const requestOptions = {
    headers: {
      'x-session-id': sessionId,
    },
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/avatar-validate?requestId=${requestId}&avatar=${avatarImg}`,
    requestOptions,
  );
}

export async function deleteAvatarImage(sessionId: string, connectionId: string, payload: deleteAvatarImagePayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'DELETE',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/delete_avatar`,
    requestOptions,
  );
}

export async function updateInputAreaOption(sessionId: string, connectionId: string, payload: any) {
  if (!sessionId || !connectionId) return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };
  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/text_input_config`,
    requestOptions,
  );
}

export async function updateSelectedFontFile(sessionId: string, connectionId: string, payload: selectedFontPayload) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/chat/${connectionId}/update_selected_font`,
    requestOptions,
  );
}

export async function updateRealTimeTranslation(sessionId: string, connectionId: string, payload: any) {
  if (!sessionId || !connectionId) return;
  const requestOptions = {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };
  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/real-time-translation/${connectionId}`,
    requestOptions,
  );
}
